<template>
  <div>
    {{rowValue}}
  </div>
</template>

<script>
export default {
    components: {
    
    },
    props: {
        cellData: {
            type: Object,
            default: () => {},
        }
    },
    data: function ()
    {
        return {
            rowValue:"",
        }
    },
    mounted() {
        //this.rowValue = "ss";
        console.log("LIST RELATED VALUE ",this.cellData);
        if (this.cellData.value) {
        // 👇️ this runs
            this.rowValue = this.cellData.value.name;
        }
        
    }
}
</script>

<style>

</style>